
import { Component, Mixins } from 'vue-property-decorator';
import NaviFollowSearchnavi from '@/components/navi/NaviFollowSearchnavi';
import NaviSerchnavi from '@/components/navi/NaviSerchnavi/NaviSerchnaviEn.vue';
import { isVisibleLineBanner } from '@/lib/functions';
import store from '@/store';
const Words: Dictionary = {
  btSearchBox: 'Search for hotels',
  btClose: 'CLOSE',
};
@Component({
  components: {
    NaviSerchnavi,
  },
})
export default class NaviFollowSearchnaviJa extends Mixins(NaviFollowSearchnavi) {
  private words = Words;
  private showLinebnr = false;
  get visibleLineBanner(): boolean {
    return isVisibleLineBanner({
      lang: store.getters['auth/lang'],
      group: store.getters['auth/group'],
      isLineLogin: store.getters['auth/line'],
    });
  }
}
